import { Component, OnInit } from '@angular/core';
import { InstaService } from '../insta.service';
import { ShopService } from '../shop.service';
import { PostsService } from '../posts.service';
import { Title } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, APP_ID, Inject } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public products;
  public instaFeed;
  public loading:boolean;
  // public mainFeature;
  // public secondaryFeature;
  public features;

  public getThumb (post) {
    return post.featured_image.FrontPageThumbnail ? post.featured_image.FrontPageThumbnail.url : post.featured_image.url;
  }

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private posts: PostsService, private shop: ShopService, private titleService:Title) { }

  ngOnInit() {
    this.loading = true;
    this.titleService.setTitle("Bender Hardware");

    this.posts.getFeatured().subscribe((response) => {
      if (response && response[0]) {}
      this.features = response[0];

      console.log("this.features: ", this.features);

      
      this.loading = false;
    });

    // this.insta.getPosts().then(feed => {
    //   console.log(feed);
    //   this.instaFeed = feed;
    // }).catch(console.error);

    // if (isPlatformBrowser(this.platformId)) {
    //   this.shop.getHomepageProducts().then((res) => {
    //     this.products = res.products;
    //   }).catch(err => {
    //     this.products = [];
    //     console.error("products: ", err);
    //   });
    // } else {
    //   this.shop.getHomepageProductsServerside().subscribe((res) => {
    //     this.products = res.products;
    //   });
    // }
    
  }

}



// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/home/home.component.ts